import React, {useEffect, useRef} from "react";

export default function FilterGroup(props) {
	// const [loading, setLoading] = useState(false)
	const parentRef = useRef(null)
	useEffect(() => {
		if (parentRef.current) {
			props.onInit(parentRef)
		}
	}, [props])

	return (
		<div className={'theme-filter mt-2 grid grid-cols-1 lg:grid-cols-12 gap-4'}>
			<form id="Search_root"
			     className="box p-0 col-span-1 lg:col-span-4 max-h-[30vh] lg:max-h-[91vh] flex flex-col flex-nowrap h-full overflow-hidden"
			     ref={parentRef}
			>
				<div className="ui form h-full overflow-auto p-4">
					<div className="grid grid-cols-2 gap-3 lg:gap-4">
						{props.children}
					</div>
				</div>
				<div className={'p-4'}>
					{props.filterFooter}
				</div>
			</form>
			<div className={'col-span-1  lg:col-span-8 max-h-[51vh] lg:max-h-[91vh] overflow-auto'}>
				{props.table}
			</div>
		</div>
	)
}
